// profile User by default
export const PERSON_DEFAULT_PROFILE = {'id': 2} 
